import React from 'react';
import { Globe, Check } from 'lucide-react';

const AutoTranslateIndicator = () => {
  return (
    <div className="flex items-center gap-2 text-sm bg-[#E0F2FE] text-[#023E8A] px-4 py-2 rounded-xl border border-[#00B4D8]/30">
      <Globe className="w-4 h-4 text-[#00B4D8]" />
      <span className="font-medium">Auto-translate active</span>
      <span className="text-[#6C757D]">— Translations to EN, FR, AR, ZH generate automatically when you save.</span>
    </div>
  );
};

export default AutoTranslateIndicator;
